module.exports = __webpack_public_path__ + "img/inter18.5fc2099b.jpg";